<template>
	<c-dialog ref="dialog" ask-close mode="slide" width="50vw" enable-flex>
		<!-- 商品信息 -->
		<div class="product-info">
			<div class="product-text">
				<p class="product-name">{{getProductText(productData)}}</p>
				<p class="info-line">背贴码：{{productData.produce_unique_code || '-'}}</p>
				<p class="info-line">IMEI：{{productData.produce_imei || '-'}}</p>
			</div>
			<div class="qrcode-area">
				<c-qrcode v-if="productData.produce_unique_code" :value="productData.produce_unique_code" size="80"></c-qrcode>
				<p class="qrcode-tip">手机端上传-扫码</p>
			</div>
		</div>

		<!-- 图片上传区域 -->
		<div class="upload-section">
			<!-- 轮播图（配件图固定第一位，选拍；其余为机器轮播图） -->
			<div class="upload-block">
				<div class="section-title">轮播图</div>
				<div class="section-tip">商品轮播图片，有配件时需传配件图，合计13张。发布到暗拍渠道（小黑暗拍 / 采货侠暗拍 / 鱼市暗拍）时可以只拍8~12张</div>
				<div class="image-list flex">
					<div class="image-item">
						<template v-if="imageMap[5].length">
							<c-file :src="imageMap[5][0].image_url" media></c-file>
							<i class="tf tf-cross remove-icon" @click="removeImage(5, 0)"></i>
							<span class="image-badge">配件</span>
						</template>
						<div v-else class="image-add flex-center z-accessory" @click="uploadAccessory()">
							<i class="tf tf-add"></i>
							<span class="add-text">配件图</span>
						</div>
					</div>
					<div v-for="(img, i) in imageMap[1]" :key="i" class="image-item">
						<c-file :src="img.image_url" media></c-file>
						<i class="tf tf-cross remove-icon" @click="removeImage(1, i)"></i>
					</div>
					<div v-if="imageMap[1].length + imageMap[5].length < imageTypeMax[1]" class="image-add flex-center" @click="uploadImage(1)">
						<i class="tf tf-add"></i>
					</div>
				</div>
			</div>

            <!-- 渠道专用轮播图（闲鱼/京东/B端靓机） -->
            <div v-for="cfg in simpleImageTypes" :key="cfg.type" class="upload-block">
                <div class="section-title">{{cfg.name}}</div>
                <div class="section-tip">{{cfg.tip}}</div>
                <div class="image-list flex">
                    <div v-for="(img, i) in imageMap[cfg.type]" :key="i" class="image-item">
                        <c-file :src="img.image_url" media></c-file>
                        <i class="tf tf-cross remove-icon" @click="removeImage(cfg.type, i)"></i>
                    </div>
                    <div v-if="imageMap[cfg.type].length < cfg.max" class="image-add flex-center" @click="uploadImage(cfg.type)">
                        <i class="tf tf-add"></i>
                    </div>
                </div>
            </div>

			<!-- B端瑕疵图 -->
			<div v-if="defectGroups[1] && defectGroups[1].length" class="upload-block">
				<div class="section-title">B端质检瑕疵图</div>
				<div class="defect-image-list flex">
					<div v-for="defect in defectGroups[1]" :key="'b_'+defect.release_parent_id" class="defect-image-item">
						<div class="defect-image-box">
							<template v-if="defect.image_url">
								<c-file :src="defect.image_url" media></c-file>
								<i class="tf tf-cross remove-icon" @click="removeDefectImage(defect)"></i>
							</template>
							<div v-else class="image-add flex-center" @click="uploadDefectImage(defect)">
								<i class="tf tf-add"></i>
							</div>
						</div>
						<div class="defect-label">{{defect.parent_name}}</div>
						<div class="defect-value z-defect">{{defect.release_name || '-'}}</div>
					</div>
				</div>
			</div>

			<!-- C端瑕疵图 -->
			<div v-if="defectGroups[2] && defectGroups[2].length" class="upload-block">
				<div class="section-title">C端质检瑕疵图</div>
				<div class="defect-image-list flex">
					<div v-for="defect in defectGroups[2]" :key="'c_'+defect.release_parent_id" class="defect-image-item">
						<div class="defect-image-box">
							<template v-if="defect.image_url">
								<c-file :src="defect.image_url" media></c-file>
								<i class="tf tf-cross remove-icon" @click="removeDefectImage(defect)"></i>
							</template>
							<div v-else class="image-add flex-center" @click="uploadDefectImage(defect)">
								<i class="tf tf-add"></i>
							</div>
						</div>
						<div class="defect-label">{{defect.parent_name}}</div>
						<div class="defect-value z-defect">{{defect.release_name || '-'}}</div>
					</div>
				</div>
			</div>


		</div>

		<template #button>
			<c-button size="dialog" color="main" @click="submitHandle">确定</c-button>
			<c-button size="dialog" @click="$refs.dialog.close()">关闭</c-button>
		</template>
	</c-dialog>
</template>

<script>
export default {
	name: 'qualityUploadImage',

	data() {
		return {
			productData: {},
			// 原始扁平图片列表（与查询接口返回结构一致，含 id 字段）
			imageList: [],
			// UI展示用：各轮播类图片 {id, image_url}（1轮播图 3闲鱼轮播图 4京东轮播图 5配件图 6B端靓机轮播图）
			imageMap: {
				1: [],
				3: [],
				4: [],
				5: [],
				6: []
			},
			// 各类型可上传张数上限（轮播图与配件图共用13张额度：有配件时机器图12张，无配件时13张）
			imageTypeMax: {1: 13, 3: 2, 4: 1, 5: 1, 6: 2},
			// 渠道专用轮播图通用区块配置（顺序即展示顺序，tip为上传说明）
			simpleImageTypes: [
                {type: 6, name: 'B端靓机轮播图', max: 2, tip: '上架小黑靓机 / 采货侠靓机 / 鱼市靓机必传，需2张'},
				{type: 3, name: '闲鱼严选渠道轮播图', max: 2, tip: '上架闲鱼严选渠道必传，需2张'},
				{type: 4, name: '京东首图', max: 1, tip: '上架京东渠道必传，需1张'},
			],
			// UI展示用：瑕疵项分组 {1: [B端...], 2: [C端...]}，每项自带 image_url
			defectGroups: {1: [], 2: []},
			imageTypeList: [
				{type: 1, name: '轮播图'},
				{type: 2, name: '瑕疵图'},
				{type: 3, name: '闲鱼严选渠道轮播图'},
				{type: 4, name: '京东首图'},
				{type: 5, name: '配件图'},
				{type: 6, name: 'B端靓机轮播图'}
			]
		}
	},

	methods: {
		/*********打开弹框**********/
		open(data) {
			this.productData = data || {};
			this.imageList = [];
			this.imageMap = {1: [], 3: [], 4: [], 5: [], 6: []};
			this.defectGroups = {1: [], 2: []};
			this.$refs.dialog.open({title: '上传产品图片'});
			this.loadData();
		},

		/*********获取产品信息文字**********/
		getProductText(data) {
			var parts = [];
			if (data.brand_name) parts.push(data.brand_name);
			if (data.model_name) parts.push(data.model_name);
			if (data.color_name) parts.push(data.color_name);
			if (data.memory_name) parts.push(data.memory_name);
			return parts.join(' ') || '-';
		},

		/*********加载图片及瑕疵项数据**********/
		loadData() {
			if (!this.productData.product_code_id) return;
			this.request({
				url: '/quality/image/list',
				data: {
					product_code_id: this.productData.product_code_id
				},
				success: (data) => {
					// 保存原始扁平列表作为数据源
					this.imageList = data || [];
					var map = {1: [], 3: [], 4: [], 5: [], 6: []};
					var groupMap = {1: {}, 2: {}};
				
					this.imageList.forEach(item => {
						// 非瑕疵图按类型收集 {id, image_url}
						if (item.image_type != 2 && map[item.image_type]) {
							map[item.image_type].push({id: item.id || null, image_url: item.image_url});
						}
						// 瑕疵图：按 report_type + release_parent_id 分组
						if (item.image_type == 2 && item.release_parent_id) {
							var reportType = item.report_type || 1;
							var pid = item.release_parent_id;
							if (!groupMap[reportType][pid]) {
								groupMap[reportType][pid] = {
									id: item.id || null,
									report_type: reportType,
									release_parent_id: pid,
									release_id: item.release_id,
									quality_report_id: item.quality_report_id || null,
									parent_name: item.parent_name || '-',
									release_name: item.release_name || '-',
									group_name: item.group_name || '',
									image_url: item.image_url || ''
								};
							} else if (item.image_url) {
								groupMap[reportType][pid].image_url = item.image_url;
								if (item.id) groupMap[reportType][pid].id = item.id;
							}
						}
					});
				
					this.imageMap = map;
					this.defectGroups = {
						1: Object.values(groupMap[1]),
						2: Object.values(groupMap[2])
					};
				}
			});
		},

		/*********上传配件图（合计13张满额时需先确认挤掉末位机器图）**********/
		uploadAccessory() {
			//配件图固定第1张，传满13张后再传配件必须腾出一张机器图，取末位（展示价值最低），需用户确认不静默删图
			if (this.imageMap[1].length + this.imageMap[5].length >= this.imageTypeMax[1]) {
				this.$confirm({
					message: '轮播图已传满13张，上传配件图后将移除最后1张机器图，是否继续？',
					buttonName: '继续',
					cancelButton: true,
					resolve: () => {
						this.$upload({
							type: 'image',
							count: 1,
							loading: true,
							success: (data) => {
								//选图成功后才挤位，用户取消选图时不动任何图
								if (data && data.length > 0) {
									this.imageMap[1].pop();
									this.imageMap[5] = [{id: null, image_url: data[0].path}];
								}
							}
						});
					},
					cancel: () => {}
				});
				return;
			}
			this.uploadImage(5);
		},

		/*********上传普通图片（各轮播类，张数按类型上限）**********/
		uploadImage(type) {
			var max = this.imageTypeMax[type] || 9;
			//轮播图与配件图共用13张额度，已传配件图时机器图少一张
			if (type == 1) max = max - this.imageMap[5].length;
			this.$upload({
				type: 'image',
				count: max - this.imageMap[type].length,
				loading: true,
				success: (data) => {
					var list = Array.from(data, item => ({id: null, image_url: item.path}));
					this.imageMap[type] = this.imageMap[type].concat(list);
				}
			});
		},

		/*********上传瑕疵图（选择文件，暂存本地）**********/
		uploadDefectImage(defect) {
			this.$upload({
				type: 'image',
				count: 1,
				loading: true,
				success: (data) => {
					if (data && data.length > 0) {
						this.$set(defect, 'image_url', data[0].path);
					}
				}
			});
		},

		/*********移除普通图片**********/
		removeImage(type, index) {
			this.imageMap[type].splice(index, 1);
		},

		/*********移除瑕疵图（清除 image_url，提交时不包含即为删除）**********/
		removeDefectImage(defect) {
			this.$set(defect, 'image_url', '');
		},

		/*********提交保存（构建扁平图片列表，一次性提交）**********/
		submitHandle() {
			var productCodeId = this.productData.product_code_id;
			if (!productCodeId) return;

			var images = [];

			// 1.各轮播类图片（轮播/闲鱼/京东/配件/B端靓机），sort_id 取类型内序号
			[1, 3, 4, 5, 6].forEach(type => {
				(this.imageMap[type] || []).forEach((img, idx) => {
					images.push({
						id: img.id || undefined,
						image_url: img.image_url,
						image_type: type,
						sort_id: idx
					});
				});
			});

			// 2. 瑕疵图：只提交有 image_url 的项（无图的即删除）
			[1, 2].forEach(rt => {
				(this.defectGroups[rt] || []).forEach(defect => {
					if (defect.image_url) {
						var item = {
							image_url: defect.image_url,
							image_type: 2,
							release_id: defect.release_id,
							release_parent_id: defect.release_parent_id,
							quality_report_id: defect.quality_report_id || undefined
						};
						if (defect.id) item.id = defect.id;
						images.push(item);
					}
				});
			});

			this.request({
				url: '/quality/image/upload',
				data: {
					product_code_id: productCodeId,
					images: images.length ? JSON.stringify(images) : ''
				},
				loading: true,
				success: () => {
					this.$message({message: '保存图片成功', type: 'success'});
					this.$refs.dialog.close();
					this.$emit('resolve');
				},
				fail: (msg) => {
					this.$message({message: msg || '保存失败', type: 'warn'});
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
.product-info
	display flex
	align-items flex-start
	padding 16px
	background #f0f4ff
	border-radius 4px
	margin-bottom 16px
	.product-text
		flex-grow 1
		.product-name
			font-size 16px
			font-weight bold
			color #1890ff
			margin-bottom 8px
		.info-line
			font-size 13px
			color #333
			line-height 24px
	.qrcode-area
		flex-shrink 0
		margin-left 20px
		text-align center
		>>> .c-qrcode
			width 80px
			height 80px
		.qrcode-tip
			margin-top 6px
			font-size 12px
			color #f55
.upload-section
	padding 0 16px
	.upload-block
		margin-bottom 20px
	.section-title
		display flex
		align-items center
		font-size 15px
		font-weight bold
		color #333
		margin-bottom 12px
		&::before,
		&::after
			content ''
			flex 1
			height 1px
			background #eee
		&::before
			margin-right 15px
		&::after
			margin-left 15px
	.section-tip
		margin 6px 0 10px
		font-size 13px
		line-height 20px
		color #999
		text-align left
	.image-list
		flex-wrap wrap
		gap 8px
		.image-item
			position relative
			width 80px
			height 80px
			>>> .c-file-media
				width 80px
				height 80px
			.remove-icon
				position absolute
				top -6px
				right -6px
				width 18px
				height 18px
				line-height 18px
				border-radius 50%
				font-size 12px
				text-align center
				color #fff
				background rgba(0,0,0,.5)
				cursor pointer
				&:hover
					background rgba(0,0,0,.8)
			.image-badge
				position absolute
				left 0
				bottom 0
				padding 0 6px
				font-size 12px
				line-height 18px
				color #fff
				background rgba(0,0,0,.5)
				border-radius 0 4px 0 4px
		.image-add
			width 80px
			height 80px
			border 1px dashed #d9d9d9
			border-radius 4px
			font-size 20px
			color #999
			cursor pointer
			&:hover
				border-color #1890ff
				color #1890ff
			&.z-accessory
				flex-direction column
				.add-text
					margin-top 2px
					font-size 12px
	.defect-image-list
		flex-wrap wrap
		gap 12px
		justify-content flex-start
		.defect-image-item
			width 80px
			text-align center
			.defect-image-box
				position relative
				width 80px
				height 80px
				margin 0 auto 6px
				>>> .c-file-media
					width 80px
					height 80px
				.image-add
					width 80px
					height 80px
					border 1px dashed #d9d9d9
					border-radius 4px
					font-size 20px
					color #999
					cursor pointer
					&:hover
						border-color #1890ff
						color #1890ff
				.remove-icon
					position absolute
					top -6px
					right -6px
					width 18px
					height 18px
					line-height 18px
					border-radius 50%
					font-size 12px
					text-align center
					color #fff
					background rgba(0,0,0,.5)
					cursor pointer
					&:hover
						background rgba(0,0,0,.8)
			.defect-label
				line-height: 16px;
				font-size 12px
				color #333
				margin-bottom 2px
				word-break break-all
			.defect-value
				line-height: 16px;
				font-size 12px
				font-weight 600
				&.z-defect
					color #e53e3e
</style>
